export const CLOUDFLARE_TURNSTILE_ENABLED = 'cloudflareTurnstileEnabled';
export const SHOW_FEATURE_FLAG_CONSOLE = 'showFeatureFlagConsole';
export const SEND_A_BOX = 'sendABox';
export const SHOW_MAINTENANCE_BANNER = 'showMaintenanceBanner';
export const ENABLE_INTERNAL_SKIP_FUNNEL = 'enableInternalSkipFunnel';
export const ENABLE_USABILLA = 'enableUsabilla';
export const CAN_TRACK = 'canTrack';
export const ENABLE_HOMEPAGE_QUICK_ADD = 'enableHomepageQuickAdd';
export const ALLOW_THANK_YOU_PAGE_DEVELOPMENT_WITHOUT_REDIRECTS =
  'allowThankYouPageDevelopmentWithoutRedirects';
export const REACTIVATION_ICONS = 'reactivationIcons';
export const ENABLE_TWO_FACTOR_AUTH = 'enableTwoFactorAuth';
export const ENABLE_PROMOTIONS = 'enablePromotions';
export const SHOW_REACTIVATION_HUB = 'showReactivationHub';
export const HOME_PAGE_ONBOARDING_MODAL = 'enableHomePageOnboardingModal';
export const TWO_STAGE_ORDERING_FLAG = 'enableTwoStageOrdering';
export const POST_SKIP_MODAL = 'postSkipModal';
export const TWO_STAGE_EXTRAS_FOR_YOU_ADDITION = 'twoStageExtrasForYouAddition';
export const MEAL_DETAILS_REDESIGN = 'enableMealDetailsRedesign';
